import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { SharedModule } from 'src/app/modules/shared/shared.module';
import { HttpErrorInterceptor } from 'src/app/modules/core/helpers/http-error.interceptor';
import { AdminRoutingModule } from 'src/app/modules/admin/admin-routing.module';

import { LoginComponent } from 'src/app/modules/admin/login/login.component';
import { DashboardComponent } from 'src/app/modules/admin/dashboard/dashboard.component';
import { TcbCouponsComponent } from 'src/app/modules/admin/tcb/tcb-coupons/tcb-coupons.component';

import { ShowTcbCouponComponent } from './components/show-tcb-coupon/show-tcb-coupon.component';

@NgModule({
  declarations: [
    LoginComponent,
    DashboardComponent,
    TcbCouponsComponent,
    
    ShowTcbCouponComponent
  ],
  imports: [
    AdminRoutingModule,
    CommonModule,
    SharedModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
  ],
  exports: [],
})
export class AdminModule { }
